import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root',
})
export class ApiConfigService {
      public API_ENDPOINT = '';
      public isProd;
      public CREATE_API_ENDPOINT = '';
      public RESULTS_API_ENDPOINT = '';
      public apiBasedonEnv() {
            this.isProd = environment.envName;
            if (this.isProd == "dev") {
                  this.API_ENDPOINT = 'https://dev-dqaas-services.optum.com/ocio-dataquality-service/';
                  this.CREATE_API_ENDPOINT = 'https://dev-dqaas-services.optum.com/profiling-rest-service/data-quality-profiler';
                  this.RESULTS_API_ENDPOINT = 'https://dev-dqaas-services.optum.com/profiling-api-service/data-quality-profiler';
            } else if (this.isProd == "prod") {
                  this.API_ENDPOINT = 'https://dqaas.optum.com/ocio-dataquality-service/';
                  this.CREATE_API_ENDPOINT = 'https://dqaas.optum.com/profiling-rest-service/data-quality-profiler';
                  this.RESULTS_API_ENDPOINT = 'https://dqaas.optum.com/profiling-api-service/data-quality-profiler';
            } else {
                  this.API_ENDPOINT = 'https://dqaas-stg.optum.com/ocio-dataquality-service/';
                  this.CREATE_API_ENDPOINT = 'https://dqaas-stg.optum.com/profiling-rest-service/data-quality-profiler';
                  this.RESULTS_API_ENDPOINT = 'https://dqaas-stg.optum.com/profiling-api-service/data-quality-profiler';

            }
      }
}

